<template>
  <v-main style="--appbar-offset: 64px;">
  <v-container>
    <!-- Full-width Banner -->
    <v-row no-gutters v-if="isMobile" class="mobile-banner">
      <v-col cols="12">
        <v-carousel
          v-if="banners.length > 0"
          hide-delimiters
          :cycle="true"
          :show-arrows="false"
          :transition="false" 
          height="mobileBannerHeight"
        >
          <v-carousel-item v-for="(banner, index) in banners" :key="index">
            <v-img
              :src="getImageUrl(banner.banner_images[0].banner_image_name)"
              alt="Banner"
              class="banner-image"
              height="auto"
              width="100%"
              cover
            ></v-img>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>

    <v-row no-gutters v-if="!isMobile" class="mt-n16">
      <v-col cols="12">
        <v-carousel
          v-if="banners.length > 0"
          hide-delimiters
          :cycle="false"
          :show-arrows="banners.length > 1"
          class="fill-height"
          height="auto"
        >
          <v-carousel-item v-for="(banner, index) in banners" :key="index">
            <v-img
              :src="getImageUrl(banner.banner_images[0].banner_image_name)"
              alt="GP21SHOP"
              class="banner-image"
              lazy
              height="auto"
              width="100%"
              cover
            ></v-img>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>

    

    <!-- Sections and Cards Displayed in Sets of Three -->
    <v-row class="flex-nowrap overflow-x-auto section-row mt-5" no-gutters>
  <v-col
    v-for="(section, i) in default_card"
    :key="i"
    cols="10"
    sm="6"
    md="4"
    class="pr-4"
  >
        <v-card class="my-4 modern-card mx-4" color="surface-variant">
          <v-card-item>
            <v-card-title>{{ section.title }}</v-card-title>
            <v-card-subtitle>{{ section.subtitle }}</v-card-subtitle>
          </v-card-item>
          <v-img :src="getImageUrl(section.image)"  contain></v-img>
          <v-card-text>
            {{ section.text }}
          </v-card-text>
          <v-card-actions>
            <v-btn
              :href="section.btn_link"
              rounded="xl"
              variant="elevated"
              block
              color="primary"
            >
              {{ section.btn_text || 'Lihat lebih lanjut' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Recent Products Section -->
    <v-row>
      <v-col cols="12">
        <h2 class="recent-products-title">Produk Kami</h2>
      </v-col>
      

      
      <v-col cols="12" sm="12">
        <v-data-iterator
          :items="filteredProducts"
          :items-per-page="8"
          v-model:search="search"
          :loading="loading"
        >
          <!-- Header with Pagination -->
          <template v-if="!isMobile" v-slot:header="{ page, pageCount, prevPage, nextPage }">
            <div class="text-h4 font-weight-bold mb-4">
              <v-row class="d-flex justify-center mb-2">
  <v-col cols="12" sm="10" md="8" lg="6">
    <v-text-field
      v-model="search"
      variant="solo"
      rounded="xl"
      prepend-inner-icon="mdi-magnify"
      placeholder="Cari produk kebutuhan Anda..."
      hide-details
      clearable
      class="search-box"
    ></v-text-field>
  </v-col>
</v-row>


              <!-- Filter Section: Categories and Subcategories -->
              <v-row class="d-flex justify-center">
  <v-col cols="12" sm="6" md="4" lg="3">
    <v-autocomplete
      v-model="selectedCategory"
      :items="categories"
      label="Kategori"
      item-title="category"
      item-value="category_id"
      variant="outlined"
      rounded="lg"
      density="comfortable"
      clearable
      prepend-inner-icon="mdi-shape"
      @update:model-value="selectedSubcategory = null"
    ></v-autocomplete>
  </v-col>

  <v-col cols="12" sm="6" md="4" lg="3">
    <v-autocomplete
      v-model="selectedSubcategory"
      :items="filteredSubcategories"
      label="Subkategori"
      item-title="subcategory"
      item-value="subcategory_id"
      variant="outlined"
      rounded="lg"
      density="comfortable"
      clearable
      prepend-inner-icon="mdi-layers"
      :disabled="!selectedCategory"
    ></v-autocomplete>
  </v-col>
</v-row>

              <!-- <div class="d-flex align-center justify-end">
                <v-btn
                  :disabled="page == 1"
                  class="me-2"
                  icon="mdi-arrow-left"
                  size="small"
                  variant="tonal"
                  @click="prevPage"
                ></v-btn>
                <v-btn
                  :disabled="page == pageCount"
                  icon="mdi-arrow-right"
                  size="small"
                  variant="tonal"
                  @click="nextPage"
                ></v-btn>
              </div> -->
            </div>
            
          </template>

          <template v-if="isMobile" v-slot:header>
  <!-- Search box -->
  <v-row class="d-flex justify-center mb-3 px-3">
    <v-col cols="12">
      <v-text-field
        v-model="search"
        variant="solo"
        rounded="xl"
        prepend-inner-icon="mdi-magnify"
        placeholder="Cari produk..."
        hide-details
        clearable
        class="search-box"
      ></v-text-field>
    </v-col>
  </v-row>

  <!-- Filter -->
  <v-row class="d-flex justify-center px-3 mb-2" dense>
    <v-col cols="12" sm="6">
      <v-autocomplete
        v-model="selectedCategory"
        :items="categories"
        label="Kategori"
        item-title="category"
        item-value="category_id"
        variant="outlined"
        rounded="lg"
        density="comfortable"
        clearable
        prepend-inner-icon="mdi-shape"
        @update:model-value="selectedSubcategory = null"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" sm="6">
      <v-autocomplete
        v-model="selectedSubcategory"
        :items="filteredSubcategories"
        label="Subkategori"
        item-title="subcategory"
        item-value="subcategory_id"
        variant="outlined"
        rounded="lg"
        density="comfortable"
        clearable
        prepend-inner-icon="mdi-layers"
        :disabled="!selectedCategory"
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>

          <!-- Product Cards -->
          <template v-slot:default="{ items }">
  <v-row v-if="items.length === 0" class="justify-center">
    <v-col cols="12" class="text-center">
      <v-alert type="info" border="left" icon="mdi-information">No Products Available</v-alert>
    </v-col>
  </v-row>

  <v-row v-else class="mb-2 product-row">
    <v-col
      v-for="({ raw }, i) in items"
      :key="raw.product_id || i"
      cols="6" sm="4" md="3" lg="3"
    >
      <v-card
        class="product-card"
        :elevation="2"
        rounded="xl"
      >
        <!-- Media -->
        <div class="media-wrap">
          <v-img
            :src="getProductImageUrl(raw)"
            :lazy-src="getProductImageUrl(raw)"
            :alt="raw.product_name"
            class="media-img"
            cover
          >
            <template #placeholder>
              <v-skeleton-loader type="image" class="h-100 w-100"></v-skeleton-loader>
            </template>
          </v-img>

          <!-- Optional chip subkategori -->
          <!-- <v-chip
            v-if="raw.subcategory?.subcategory"
            size="small"
            label
            class="chip-category"
            color="white"
            variant="flat"
          >
            {{ raw.subcategory.subcategory }}
          </v-chip> -->
        </div>

        <!-- Body -->
 <v-card-item class="pa-3">
    <div class="product-title text-subtitle font-weight-bold">
      {{ raw.product_name }}
    </div>
    <div class="product-price text-primary text-subtitle font-weight-medium mt-1">
      {{ raw.price_display }}
    </div>
  </v-card-item>

  <v-divider class="mx-4 mb-1"></v-divider>

  <!-- Action Button -->
  <v-card-actions>
    <v-btn
      rounded="xl"
      variant="elevated"
      block
      color="primary"
      @click="viewDetails(raw.product_id)"
    >
      Lihat detail
    </v-btn>
  </v-card-actions>

      </v-card>
    </v-col>
  </v-row>
</template>

          <template v-slot:footer="{ page, pageCount, prevPage, nextPage }">
            <div class="iterator-footer">
              <v-btn
                :disabled="page === 1"
                icon="mdi-arrow-left"
                size="small"
                variant="tonal"
                @click="prevPage"
              />
              <div class="page-indicator">
                {{ page }} / {{ pageCount }}
              </div>
              <v-btn
                :disabled="page === pageCount"
                icon="mdi-arrow-right"
                size="small"
                variant="tonal"
                @click="nextPage"
              />
            </div>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</v-main>
</template>


<script>
import numeral from "numeral";

export default {
  name: "Home",
  data() {
    return {
      default_card: [],
      banners: [],
      loading: false,
      search: "",
      categories: [], // Categories fetched from the API
      subcategories: [], // Subcategories fetched from the API
      products: [], // All products
      selectedCategory: null,
      selectedSubcategory: null,
      isMobile: window.innerWidth < 600,
      viewportWidth: window.innerWidth,
      appBarOffsetMobile: 64,
    };
  },
  async created() {
    await this.fetchBanners();
    await this.fetchHomeSections();
    await this.fetchRecentProducts();
    await this.fetchSubcategories();
    await this.fetchCategories();
  },
  mounted() {
  window.addEventListener("resize", this.onResize, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
     mobileBannerHeight() {
      const h = this.viewportWidth * 9 / 16; // rasio 16:9
      return Math.max(220, Math.min(h, 420))
     },
    sectionRows() {
      const rows = [];
      for (let i = 0; i < this.default_card.length; i += 3) {
        rows.push(this.default_card.slice(i, i + 3));
      }
      return rows;
    },
    filteredSubcategories() {
    if (!this.selectedCategory) return this.subcategories;
    return this.subcategories.filter(s => s.category_id == this.selectedCategory);
  },
  filteredProducts() {
    return this.products.filter(product => {
      const matchesCategory =
        this.selectedCategory ? product.subcategory?.category_id == this.selectedCategory : true;
      const matchesSubcategory =
        this.selectedSubcategory ? product.subcategory?.subcategory_id == this.selectedSubcategory : true;
      return matchesCategory && matchesSubcategory;
    });
  },
  },
  methods: {
    onResize() {
      this.viewportWidth = window.innerWidth;
      this.isMobile = window.innerWidth < 600;
    },
    async fetchBanners() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/banners");
        this.banners = response.data.data || [];
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchHomeSections() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/sections");
        this.default_card = response.data.data || [];
      } catch (error) {
        console.error("Error fetching home sections:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchRecentProducts() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/product-new");
        this.products = response.data.data || [];
        if (product.medias) {
          product.medias.sort((a, b) => a.display_order - b.display_order);
        }
      } catch (error) {
        console.error("Error fetching recent products:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchCategories() {
      try {
        const response = await this.$axios.get("/category");
      
      this.categories = response.data.data || [];

      } catch (error) {
        console.error("Error fetching recent products:", error);
      } finally {
        this.loading = false;
      }
      
    },
    async fetchSubcategories() {
      try {
        const response = await this.$axios.get("/subcategory");
      this.subcategories = response.data.data || [];

      } catch (error) {
        console.error("Error fetching recent products:", error);
      } finally {
        this.loading = false;
      }
      
    },
    getImageUrl(imageName) {
      return `${this.$urlImage}storage/images/${imageName}`;
    },
    getProductImageUrl(item) {
      if (item.medias && item.medias.length > 0) {
      item.medias.sort((a, b) => a.display_order - b.display_order); // Sorting images
      return this.getImageUrl(item.medias[0].media.media_name);
    }
    },
    numeralFormat(value, format) {
      return numeral(value).format(format); // Modify to use any numeral format as required
    },
    viewDetails(productId) {
      this.$router.push({ name: "product-detail", params: { id: productId } });
    },
  },
};
</script>


<style scoped>
/* --- Product Card Modern --- */
/* Judul produk */
.product-name {
  font-weight: 700;
  font-size: 1.15rem;
  line-height: 1.35rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 2px;

  /* tambahan untuk kompatibilitas linting */
  line-clamp: 2; /* standard (experimental) */
}


/* Harga */
.price {
  font-weight: 600;
  font-size: 1rem;
  color: #1f5fbf;
}

.product-card {
  transition: transform .18s ease, box-shadow .18s ease;
  background: rgb(var(--v-theme-surface));
}
@media (hover:hover) {
  .product-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
  }
  .media-img {
    transition: transform 0.25s ease;
  }
  .product-card:hover .media-img {
    transform: scale(1.05);
  }
}

/* Media area: square by default (rasio 1:1) */
.media-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;      /* konsisten di seluruh kartu */
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}
.media-img {
  width: 100%;
  height: 100%;
}

/* Subcategory chip pojok kiri-atas pada image */
.chip-category {
  position: absolute;
  top: 10px;
  left: 10px;
  --v-theme-overlay-multiplier: 0;
  backdrop-filter: blur(6px);
  box-shadow: 0 2px 10px rgba(0,0,0,.12);
}

/* Judul 2 baris max */
.title-2lines {
  font-weight: 600;
  line-height: 1.25rem;
  min-height: 2.5rem;           /* jaga tinggi konsisten */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Harga jelas & kontras */
.price {
  font-weight: 800;
  font-size: 1.05rem;
  color: #1f5fbf;               /* biru aksen */
}

/* Sedikit saku kiri/kanan di mobile supaya grid "bernafas" */
@media (max-width: 600px) {
  .product-row {
    padding-left: 8px;
    padding-right: 8px;
  }

  .v-container {
    padding-left: 8px;
    padding-right: 8px;
  }
  .recent-products-title {
    font-size: 1.5rem;
    margin: 0.5rem 0;
  }
}

/* Banner Styles */
.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.full-width-image {
  width: 100%;
  height: auto;
}

/* Card Styles */
.v-card {
  border-radius: 12px;
}

.card-title, .card-subtitle, .card-text {
  color: rgb(var(--v-theme-primary));
}

.card-title {
  font-size: 1.75rem;
}

.card-subtitle {
  font-size: 1.25rem;
}

.card-text {
  font-size: 1rem;
}

.v-card-actions {
  display: flex;
  justify-content: flex-start;
}

.section-image v-img {
  height: 300px;
  object-fit: cover;
}

.section-row {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
}
.section-row::-webkit-scrollbar {
  display: none; /* Safari/Chrome */
}


.iterator-footer {
  position: sticky;   /* nempel di bawah saat di-scroll area iterator */
  bottom: 0;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center; /* tengah untuk mobile & desktop */
  padding: 12px 8px;
  background: rgb(var(--v-theme-background));   /* pastikan kontras di atas konten */
  border-top: 1px solid rgba(0,0,0,0.06);
  z-index: 1;
}

.page-indicator {
  font-weight: 600;
  min-width: 64px;
  text-align: center;
}

/* Responsive Banner */
@media (max-width: 600px) {
  .banner-image {
    height: 300px;
    width: 100%;
  }


.mobile-banner .v-img {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}



  .v-main {
  margin: 0;
  padding: 0;
}

.v-container {
  margin: 0;
  padding-left: 0;
    padding-right: 0;
}

.product-row {
    padding-left: 8px;
    padding-right: 8px;
  }
}


/* Recent Products Section */
.recent-products-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 1rem 0;
  color: rgb(var(--v-theme-primary));
  text-align: center;
}



/* Make sure products and cards scale well on smaller screens */
@media (max-width: 768px) {
  .v-card {
    margin: 8px auto;
  }
}

</style>


